<template>
  <div class="detail-item">
    <div class="row align-items-start">
      <div class="col-12 col-md-5 order-md-1 mb-5">
        <div class="mb-4">
          <div>
            <h5 v-dynamic-content:pv_gross_25y_savings_title></h5>
            <p v-dynamic-content:pv_gross_25y_savings_text="[grossSavingsAsPrice]"></p>
          </div>
        </div>
        <div class="mb-4">
          <div>
            <h5 v-dynamic-content:pv_net_25y_savings_totals_title></h5>
            <p v-dynamic-content:pv_net_25y_savings_totals_text="[netSavingsAsPrice]"></p>
          </div>
        </div>
        <div class="overviewtables mb-4">
          <detail-general-information :quote="quote"></detail-general-information>
        </div>
        <div
          class="overviewtables mb-4"
          v-if="quote.detailOverview.batteryCapacity || quote.detailOverview.batteryDegradation"
        >
          <detail-battery-information :quote="quote"></detail-battery-information>
        </div>
        <div
          class="overviewtables mb-4"
          v-if="quote.detailOverview.batterySubsidy || quote.detailOverview.pvSubsidy"
        >
          <detail-subsidy-information :quote="quote"></detail-subsidy-information>
        </div>
        <div class="overviewtables mb-4">
          <detail-expense-information :quote="quote"></detail-expense-information>
        </div>
      </div>

      <div class="col-12 col-md-7 order-md-2">
        <div class="overviewtables">
          <detail-year-overview :quote="quote"></detail-year-overview>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailGeneralInformation from '@/components/quotes/DetailGeneralInformation'
import DetailExpenseInformation from '@/components/quotes/DetailExpenseInformation'
import DetailYearOverview from '@/components/quotes/DetailYearOverview'
import DetailSubsidyInformation from '@/components/quotes/DetailSubsidyInformation'
import DetailBatteryInformation from '@/components/quotes/DetailBatteryInformation'

export default {
  name: 'DetailCalculation',
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  components: {
    DetailGeneralInformation,
    DetailYearOverview,
    DetailExpenseInformation,
    DetailSubsidyInformation,
    DetailBatteryInformation,
  },
  computed: {
    grossSavingsAsPrice() {
      return this.$options.filters.formatCurrency(this.quote.detailOverview.annualSavingsTotal)
    },
    netSavingsAsPrice() {
      return this.$options.filters.formatCurrency(
        this.quote.detailOverview.annualSavingsTotal -
          // TODO Which field from the Odoo API to use in this case?
          this.quote.detailOverview.contractPriceExclVAT ||
          this.quote.detailOverview.contractPrice
      )
    },
  },
}
</script>
